import CryptoJS from 'crypto-js';

function EncryptData(data) {
  const { REACT_APP_ENCRYPT_KEY } = process.env;
  const apiKey = REACT_APP_ENCRYPT_KEY;

  // console.log('Original data:', data);

  // Validate the API key
  if (!apiKey) {
    throw new Error('Encryption key is missing');
  }

  // Generate IV
  let iv = CryptoJS.lib.WordArray.random(16);
  // console.log('Generated IV:', iv.toString());

  // Parse the key
  const key = CryptoJS.enc.Base64.parse(apiKey);
  // console.log('Parsed key:', key.toString());

  const options = {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  };

  // Convert data to string
  const dataString = JSON.stringify(data);
  // console.log('Data string:', dataString);

  // Encrypt the data
  let encrypted = CryptoJS.AES.encrypt(dataString, key, options);
  encrypted = encrypted.toString();
  // console.log('Encrypted data:', encrypted);

  // Encode IV and create result object
  iv = CryptoJS.enc.Base64.stringify(iv);
  let result = {
    iv,
    value: encrypted,
    mac: CryptoJS.HmacSHA256(iv + encrypted, key).toString()
  };

  // console.log('Result object:', result);

  // Convert result to string and encode to Base64
  result = JSON.stringify(result);
  // console.log('Result string:', result);

  result = CryptoJS.enc.Utf8.parse(result);
  return CryptoJS.enc.Base64.stringify(result);
}

export default EncryptData;

// import CryptoJS from 'crypto-js';

// function EncryptData(data) {
//   const { REACT_APP_ENCRYPT_KEY } = process.env;
//   const apiKey = REACT_APP_ENCRYPT_KEY;

//   console.log(data, 'data');

//   let iv = CryptoJS.lib.WordArray.random(16);
//   const key = CryptoJS.enc.Base64.parse(apiKey);
//   const options = {
//     iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   };
//   let encrypted = CryptoJS.AES.encrypt(data.toString(), key, options);
//   encrypted = encrypted.toString();
//   iv = CryptoJS.enc.Base64.stringify(iv);
//   let result = {
//     iv,
//     value: encrypted,
//     mac: CryptoJS.HmacSHA256(iv + encrypted, key).toString()
//   };
//   result = JSON.stringify(result);
//   result = CryptoJS.enc.Utf8.parse(result);
//   return CryptoJS.enc.Base64.stringify(result);
// }

// export default EncryptData;
